export default __webpack_public_path__ + "img/7fd185a37fa9b8489021b37637f07d18.svg";